export const status = [{ value: 'ACTIVE' }, { value: 'INACTIVE' }];

export const taxStatus = [{ value: 'TAXABLE' }, { value: 'EXEMPT' }];

export const categoryStatus = [
  { value: 'READY_MIX', label: 'Ready Mix' },
  { value: 'ASPHALT', label: 'Asphalt' },
  { value: 'AGGREGATE', label: 'Aggregate' },
];
